"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var semantic_1 = require("./semantic");
exports.default = {
    semantic: semantic_1.default,
};
